import * as request from '@/utils/request'

/**
 * 应用管理（第三方应用配置，数据表：mini_apps）
 */

export default {
  /**
   * @description 获取应用列表
   * @param {*} data
   * @returns
   */
  getMiniAppList(data) {
    return request.post('/mini_app/list', data)
  },
  /**
   * @description 保存应用配置（新增/修改）
   * @param {*} data
   * @returns
   */
  saveMiniApp(data) {
    return request.post('/mini_app/store', data)
  },
  /**
   * @description 获取应用详情
   * @param {*} id
   * @returns
   */
  getMiniAppInfo(id) {
    return request.post('/mini_app/get_info', { id: id })
  },
  /**
   * @description 启用/停用
   * @param {*} id
   * @param {*} state 0：禁用，1：启用
   * @returns
   */
  changeMiniAppState(id, state) {
    return request.post('/mini_app/change_state', { id: id, state: state })
  },
  /**
   * @description 删除应用配置
   * @param {*} id
   * @returns
   */
  deleteMiniApp(id) {
    return request.post('/mini_app/delete', { id: id })
  },
  /**
   * @description 应用类型/状态/配置参考字段
   * @param {*} type
   * @returns
   */
  getMiniAppMeta(type) {
    return request.post('/mini_app/meta', { type: type })
  },
  /**
   * @description 启用中的应用下拉
   * @param {*} type
   * @returns
   */
  getMiniAppOptions(type) {
    return request.post('/mini_app/options', { type: type })
  }
}
